import React from "react";

/** columns: [{ key, label, render?(row), className?, num? }] */
export default function Table({ columns, rows, actions, empty = "موردی ثبت نشده است", loading, rowClass }) {
  if (loading) return <div className="empty"><div className="spinner" style={{ margin: "0 auto" }} /></div>;
  if (!rows.length) return <div className="empty"><i className="fa-regular fa-folder-open" />{empty}</div>;
  return (
    <div className="table-wrap">
      <table className="tbl">
        <thead>
          <tr>
            {columns.map((c) => <th key={c.key} className={c.num ? "num" : ""}>{c.label}</th>)}
            {actions && <th style={{ width: 1 }} />}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
     <tr key={r.id ?? i} className={rowClass ? rowClass(r) : undefined}>
              {columns.map((c) => (
                <td key={c.key} className={`${c.className || ""} ${c.num ? "num" : ""}`}>
                  {c.render ? c.render(r) : (r[c.key] ?? "—")}
                </td>
              ))}
              {actions && <td><div className="actions">{actions(r)}</div></td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const TONE = { done: "ok", approved: "ok", in_progress: "warn", pending: "wait", rejected: "bad" };
export const StatusBadge = ({ status, label }) => <span className={`badge ${TONE[status] || "wait"}`}>{label}</span>;
